import StoneForm from './StoneForm'

export default StoneForm
